import { RVEntityTags } from "@regal-voice/ui";
import { JourneyWithMetrics } from "Types/Journey";

export function JourneysTags({ record }: { record: JourneyWithMetrics }): JSX.Element {
    return <RVEntityTags tags={record.tags} dataTestId="no-journey-tags" />;
}
